"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageContainer = exports.StockStatusNumber = exports.StockStatusMessage = exports.StockAmountBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Types_1 = require("Types");
const Typography_1 = __importDefault(require("../../../../Components/UI/Typography"));
exports.StockAmountBlock = styled_components_1.default.div `
  display: flex;
  align-items: center;
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW && `margin-bottom: ${props.theme.spacing.s2}px;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `margin-bottom: ${props.theme.spacing.s4}px;`}

  ${props => props.variantType === Types_1.VariantTypes.PRODUCT_VIEW &&
    `
    margin-top: ${props.theme.spacing.s4}px;
  `}
  
  ${props => (props === null || props === void 0 ? void 0 : props.columnDirection) &&
    `
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: ${props.theme.breakpoints.xxxl}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW && !(props === null || props === void 0 ? void 0 : props.isOrderPrint) && `flex-direction: row;`}
    }

    @media (max-width: ${props.theme.breakpoints.lg}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW && `flex-direction: row;`}
    }

    @media (max-width: ${props.theme.breakpoints.xs}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW && `flex-direction: column;`}
    }
  `}

  

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      margin-bottom: ${props.theme.spacing.s4}px;
    `}
  }
`;
exports.StockStatusMessage = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s7}px;
  color: ${props => props.theme.palette.BW_0};
`;
exports.StockStatusNumber = (0, styled_components_1.default)(Typography_1.default) `
  margin-left: ${props => props.theme.spacing.s1}px;
  color: ${props => props.theme.palette.HALDEX_BLUE};

  ${props => props.columnDirection &&
    `
    margin: ${props.theme.spacing.s7}px 0 0 ${props.theme.spacing.s5}px;

    @media (min-width: ${props.theme.breakpoints.xxxl}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW && `margin: 0 0 0 ${props.theme.spacing.s2}px;`}
    }

    @media (max-width: ${props.theme.breakpoints.lg}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW && `margin: 0 0 0 ${props.theme.spacing.s2}px;`}
    }

    @media (max-width: ${props.theme.breakpoints.xs}px) {
      ${props.variantType === Types_1.VariantTypes.PRODUCT_VIEW &&
        `margin: ${props.theme.spacing.s7}px 0 0 ${props.theme.spacing.s5}px;`}
    }
  `}
`;
exports.MessageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.default = {
    StockAmountBlock: exports.StockAmountBlock,
    StockStatusMessage: exports.StockStatusMessage,
    StockStatusNumber: exports.StockStatusNumber,
    MessageContainer: exports.MessageContainer
};
